<template>
    <v-container pa-0 class="align-self-end">
        <v-card class="pa-2"
                flat
                tile>
            <h2 class="headline font-weight-bold mb-3">
                Error
            </h2>
            <p class="body-1">Sorry, something went wrong. Please try again later!</p>
            <div class="d-flex">
                <v-btn color="primary darken-1" @click="reloadApplication">Try Again</v-btn>
            </div>
        </v-card>
    </v-container>
</template>

<script>
    import { mapActions } from 'vuex';

    export default {
        name: 'application-error',
        methods: {
            ...mapActions([
                'setBoolean',
                'fetchBootstrap',
            ]),
            async reloadApplication() {
                window.location.reload();
            },
        }
    }
</script>
